import React from 'react'
import { Disclosure } from '@headlessui/react'
import { MenuIcon, XIcon } from '@heroicons/react/outline'
import NavLinks  from './NavLinks'
import NavLinkM from './NavLinkM'

import '../../Main.css'

const navigation = [
    { id:1, name: 'CDSoft', href: '/' },
    { id:2, name: 'Privacy Policy', href: '/privacypolicy' },
]

const logoURL = require('../../assets/img/logo.svg').default; // with require

function NavBar() {

    return (
        <Disclosure as="nav" className="bg-blue-654C">
            {({ open }) => (
                <>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex items-center justify-between h-16">
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <img
                                        className="h-16 w-16"
                                        src={logoURL}
                                        alt="UFG-Logo"
                                    />
                                </div>
                                <div className="hidden md:block">
                                    <div className="ml-10 flex items-baseline space-x-4">
                                        {navigation.map(({id, ...data}) => (
                                            <NavLinks key={id} {...data} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="-mr-2 flex md:hidden">
                                {/* Mobile menu button */}
                                <Disclosure.Button className="bg-blue-3005C inline-flex items-center justify-center p-2 rounded-md text-orange-100 hover:text-white hover:bg-blue-2915C focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-white">
                                    <span className="sr-only">Open main menu</span>
                                    {open ? (
                                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                                    ) : (
                                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                    )}
                                </Disclosure.Button>
                            </div>
                        </div>
                    </div>

                    <Disclosure.Panel className="md:hidden">
                        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                            {navigation.map(({id, ...data}) => (
                                <NavLinkM key={id} {...data}/>
                            ))}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    )
}

export default NavBar